import React, { useState } from 'react';
import axios from '../../config/axiosConfig'; 
import { STATES, UNION_TERRITORIES } from '../../constants/indianStates'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Broadcasting = () => {
  const [formData, setFormData] = useState({
    // Personal Information
    fullName: '',
    address: '',
    city: '',
    state: '',
    district: '',
    pinCode: '',
    areaWardNo: '',
    areaPoliceStation: '',
    talukOrZone: '',
    mlaConstituency: '',
    mpConstituency: '',
    mobile: '',
    whatsapp: '',
    email: '',
    dateOfBirth: '',
    gender: '',
    maritalStatus: '',
    educationQualification: '',
    nationality: '',
    natureOfBusiness: '',
    occupation: '',
    proposerName: '',
    fatherSpouseName: '',

    languagesKnown: {
            english: false,
            hindi: false,
            tamil: false,
            malayalam: false,
            telugu: false,
            kannada: false,
            other: false
          },
          otherLanguage: '',
    
    // Media Details
    mediaType: '',
    channelIdentityName: '',
    companyName: '',
    proprietorName: '',
    phone: '',
    channelEmail: '',
    channelRegdNo: '',
    website: '',
    category: '',
    channelLanguage: '',
    yearStarted: '',
    editorName: '',
    editorPhone: '',
    officeAddress: '',
    
    // Uploads
    idProof: null,
    photograph: null,
    signature: null,
    addressProof: null,
    
    // Declaration
    declaration: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'file') {
      const file = files[0];
      setFormData(prev => ({
        ...prev,
        [name]: file
      }));
    } else if (name.startsWith('language_')) {
      const languageId = name.replace('language_', '');
      setFormData(prev => ({
        ...prev,
        languagesKnown: {
          ...prev.languagesKnown,
          [languageId]: checked
        }
      }));
    } else if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      const submitData = new FormData();
      
      // Map frontend keys to backend snake_case keys
      const fieldMapping = {
        fullName: 'full_name',
        pinCode: 'pin_code',
        areaWardNo: 'area_ward_no',
        areaPoliceStation: 'area_police_station',
        talukOrZone: 'taluk_or_zone',
        mlaConstituency: 'mla_constituency',
        mpConstituency: 'mp_constituency',
        dateOfBirth: 'date_of_birth',
        maritalStatus: 'marital_status',
        educationQualification: 'education_qualification',
        natureOfBusiness: 'nature_of_business',
        proposerName: 'proposer_name',
        fatherSpouseName: 'father_spouse_name',
        languagesKnown: 'languages_known',
        otherLanguage: 'other_language',
        
        // Media Details Mapping
        mediaType: 'media_type',
        channelIdentityName: 'channel_identity_name',
        companyName: 'company_name',
        proprietorName: 'proprietor_name',
        // phone maps to phone
        channelEmail: 'channel_email',
        channelRegdNo: 'channel_regd_no',
        // website maps to website
        // category maps to category
        channelLanguage: 'channel_language',
        yearStarted: 'year_started',
        editorName: 'editor_name',
        editorPhone: 'editor_phone',
        officeAddress: 'office_address',

        idProof: 'id_proof',
        addressProof: 'address_proof'
      };

      // Append all form data to FormData object
      Object.keys(formData).forEach(key => {
        const backendKey = fieldMapping[key] || key;
        
        if (key === 'languagesKnown') {
          submitData.append(backendKey, JSON.stringify(formData[key]));
        } else if (key === 'website') {
           // Auto-prepend https:// if missing
           let websiteValue = formData[key];
           if (websiteValue && !websiteValue.startsWith('http://') && !websiteValue.startsWith('https://')) {
               websiteValue = `https://${websiteValue}`;
           }
           submitData.append(backendKey, websiteValue);
        } else if (['idProof', 'photograph', 'signature', 'addressProof'].includes(key)) {
          if (formData[key] instanceof File) {
            submitData.append(backendKey, formData[key]);
          }
        } else {
          submitData.append(backendKey, formData[key]);
        }
      });

      const response = await axios.post('forms/broadcasting-media-applications/', submitData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 201) {
        const successMsg = 'Your responses were successfully submitted. Thank you Call 7200024451/52 for further processes.';
        toast.success(successMsg);
        setMessage(successMsg);
        setFormData({
          fullName: '',
          address: '',
          city: '', 
          state: '',
          district: '',
          pinCode: '',
          areaWardNo: '',
          areaPoliceStation: '',
          talukOrZone: '',
          mlaConstituency: '',
          mpConstituency: '',
          mobile: '',
          whatsapp: '',
          email: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          educationQualification: '',
          nationality: '',
          natureOfBusiness: '',
          occupation: '',
          proposerName: '',
          fatherSpouseName: '',
          languagesKnown: {
            english: false,
            hindi: false,
            tamil: false,
            malayalam: false,
            telugu: false,
            kannada: false,
            other: false
          },
          otherLanguage: '',
          
          mediaType: '',
          channelIdentityName: '',
          companyName: '',
          proprietorName: '',
          phone: '',
          channelEmail: '',
          channelRegdNo: '',
          website: '',
          category: '',
          channelLanguage: '',
          yearStarted: '',
          editorName: '',
          editorPhone: '',
          officeAddress: '',

          idProof: null,
          photograph: null,
          signature: null,
          addressProof: null,
          declaration: false
        });
        
        // Reset file inputs
        document.getElementById('idProof').value = '';
        document.getElementById('photograph').value = '';
        if (document.getElementById('signature')) document.getElementById('signature').value = '';
        if (document.getElementById('addressProof')) document.getElementById('addressProof').value = '';
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      let errorMsg = 'Error submitting application. Please try again.';
      
      if (error.response && error.response.data) {
          if (error.response.data.detail) {
              errorMsg = error.response.data.detail;
          } else {
              const validationErrors = Object.entries(error.response.data)
                  .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`)
                  .join('\n');
              if (validationErrors) {
                  errorMsg = `Validation Error:\n${validationErrors}`;
              }
          }
      }
      toast.error(errorMsg);
      setMessage(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section 
        className="relative bg-blue-900 text-white py-20 bg-cover bg-center bg-no-repeat mb-10"
        style={{ backgroundImage: "url('/images/broadcasting.png')" }}
      >
        <div className="absolute inset-0 bg-blue-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 uppercase">
              Broadcasting Media Application Form
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Fill out the form below to apply for NAI Broadcasting Media Membership
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">

        <div className='mb-6'>
            <div className='text-gray-600 text-justify'>
                By joining NAI you become part of one of the most forward thinking professional network focusing on innovation in journalism. As a NAI member, you will receive invitations to the NAI events.
If you agree with our manifesto and you affirm that you are aware of our statutes please start the membership registration process using the form below.
    <br/>
Before fill the form, scan your Passport size photo, scanned copy of your signature, 
scanned copy of your any Id Proof and Address proof (Approved by central or state Government) 
keep it ready to upload.
            </div>
        </div>


        <ToastContainer />

        <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Personal Information Section - SAME AS PressMedia */}
          <div className="p-6 border-b border-gray-200 mb-6">
            <h2 className="text-3xl font-semibold text-blue-800 pb-10 uppercase">
              Personal Information
            </h2>

            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="fullName" className="block text-sm font-medium text-gray-600 mb-1">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="fatherSpouseName" className="block text-sm font-medium text-gray-600 mb-1">
                  Father / Spouse Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="fatherSpouseName"
                  name="fatherSpouseName"
                  value={formData.fatherSpouseName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>    

              <div>
                <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-600 mb-1">
                  Date of Birth <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  required
                  className="w-full italic px-3 text-sm text-gray-500 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="gender" className="block text-sm font-medium text-gray-600 mb-1">
                  Gender <span className="text-red-500">*</span>
                </label>
                <select
                  id="gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                  className="w-full px-3 italic py-2 text-sm border text-gray-500   border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>

               <div>
                <label htmlFor="maritalStatus" className="block text-sm font-medium text-gray-600 mb-1">
                  Marital Status <span className="text-red-500">*</span>
                </label>
                <select
                  id="maritalStatus"
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  onChange={handleChange}
                  required
                  className="w-full px-3 italic py-2 text-sm border text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select Marital Status</option>
                  <option value="married">Married</option>
                  <option value="single">Single</option>
                                  
                </select>
              </div>

                 <div>
                <label htmlFor="educationQualification" className="block text-sm font-medium text-gray-600 mb-1">
                  Education Qualification <span className="text-red-500">*</span>
                </label>
                <select
                  id="educationQualification"
                  name="educationQualification"
                  value={formData.educationQualification}
                  onChange={handleChange}
                  required
                  className="w-full px-3 italic py-2 text-sm border text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select Education Qualification</option>
                  <option value="non_graduate">Non-Graduate</option>
                  <option value="diploma">Diploma</option>
                  <option value="graduate">Graduate</option>
                  <option value="post_graduate">Post Graduate</option>
                  <option value="doctorate">Doctorate</option>
                </select>
              </div>

              <div>
                <label htmlFor="mobile" className="block text-sm font-medium text-gray-600 mb-1">
                  Mobile Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div>
                <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-600 mb-1">
                  Whatsapp Number 
                </label>
                <input
                  type="tel"
                  id="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              
              <div className="">
                <label htmlFor="email" className="block text-sm font-medium text-gray-600 mb-1">
                  Email Address 
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Language Known Section */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Languages Known <span className="text-red-500">*</span>
                </label>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                  {[
                    { id: 'english', label: 'English' },
                    { id: 'hindi', label: 'Hindi' },
                    { id: 'tamil', label: 'Tamil' },
                    { id: 'malayalam', label: 'Malayalam' },
                    { id: 'telugu', label: 'Telugu' },
                    { id: 'kannada', label: 'Kannada' },
                    { id: 'other', label: 'Other' }
                  ].map((language) => (
                    <div key={language.id} className="flex items-center">
                      <input
                        type="checkbox"
                        id={`language_${language.id}`}
                        name={`language_${language.id}`}
                        checked={formData.languagesKnown[language.id]}
                        onChange={handleChange}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <label htmlFor={`language_${language.id}`} className="ml-2 text-sm text-gray-700">
                        {language.label}
                      </label>
                    </div>
                  ))}
                </div>
                
                {/* Other Language Input */}
                {formData.languagesKnown.other && (
                  <div className="mt-3">
                    <label htmlFor="otherLanguage" className="block text-sm font-medium text-gray-700 mb-1">
                      Specify Other Language <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="otherLanguage"
                      name="otherLanguage"
                      value={formData.otherLanguage}
                      onChange={handleChange}
                      required={formData.languagesKnown.other}
                      placeholder="Enter language name"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                )}
              </div>
            

              <div className="md:col-span-2">
                <label htmlFor="address" className="block text-sm font-medium text-gray-600 mb-1">
                  Address <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="city" className="block text-sm font-medium text-gray-600 mb-1">
                  City <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="state" className="block text-sm font-medium text-gray-600 mb-1">
                  State <span className="text-red-500">*</span>
                </label>
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border text-sm italic text-gray-400 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select State</option>
                  <optgroup label="States">
                    {STATES.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="Union Territories">
                    {UNION_TERRITORIES.map((ut) => (
                      <option key={ut} value={ut}>
                        {ut}
                      </option>
                    ))}
                  </optgroup>
                </select>
              </div>

              <div>
                <label htmlFor="district" className="block text-sm font-medium text-gray-600 mb-1">
                  District <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="district"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="pinCode" className="block text-sm font-medium text-gray-600 mb-1">
                  PIN Code <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="pinCode"
                  name="pinCode"
                  value={formData.pinCode}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div className="md:col-span-2 my-4">
                <hr className="border-blue-300 " />
              </div>
            

              <div>
                <label htmlFor="areaWardNo" className="block text-sm font-medium text-gray-600 mb-1">
                  Area Ward No / Village <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="areaWardNo"
                  name="areaWardNo"
                  value={formData.areaWardNo}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="talukOrZone" className="block text-sm font-medium text-gray-600 mb-1">
                  Taluk or Zone <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="talukOrZone"
                  name="talukOrZone"
                  value={formData.talukOrZone}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="mlaConstituency" className="block text-sm font-medium text-gray-600 mb-1">
                  MLA Constituency 
                </label>
                <input
                  type="text"
                  id="mlaConstituency"
                  name="mlaConstituency"
                  value={formData.mlaConstituency}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div>
                <label htmlFor="mpConstituency" className="block text-sm font-medium text-gray-600 mb-1">
                  MP Constituency 
                </label>
                <input
                  type="text"
                  id="mpConstituency"
                  name="mpConstituency"
                  value={formData.mpConstituency}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

                <div>
                <label htmlFor="areaPoliceStation" className="block text-sm font-medium text-gray-600 mb-1">
                  Area Police Station <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="areaPoliceStation"
                  name="areaPoliceStation"
                  value={formData.areaPoliceStation}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>


             <div className="md:col-span-2 my-4">
                <hr className="border-blue-300 " />
              </div>
              
            

            <div>
                <label htmlFor="natureOfBusiness" className="block text-sm font-medium text-gray-600 mb-1">
                  Nature of Business  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="natureOfBusiness"
                  name="natureOfBusiness"
                  value={formData.natureOfBusiness}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="occupation" className="block text-sm font-medium text-gray-600 mb-1">
                  Occupation <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="occupation"
                  name="occupation"
                  value={formData.occupation}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Note: Designation is NOT in Broadcasting personal info section in original form? 
                  Assuming reuse of personal section, designation was there. 
                  But in Broadcasting image it is not explicitly in Personal Info.
                  However, I will keep it if it fits, or remove it.*/}
              
              {/* Checking the image again... the image only shows "Media Details". 
                  The user said "Broadcasting.jsx ... is same as PressMedia.jsx. only Media Details differ".
                  So I assume Personal Info is identical. 
                  PressMedia Personal Info had 'Designation', but wait,
                  PressMedia has Designation under PERSONAL info?
                  Let me check PressMedia again.
                  Lines 736-748 in PressMedia.jsx: Designation is in Personal Info Section.
                  So I'll keep it? Or maybe it's cleaner to handle it.
                  Wait, Broadcasting Media Details DOES NOT start with Designation.
                  Let's check the image again.
                  The image starts with "Media Details".
                  It has "Media Type", "Name of Channel Identity", "Company Name", "Proprietor Name".
                  So I will replace "Professional Information" section of PressMedia with "Media Details" section for Broadcasting.
              */}

               <div>
                <label htmlFor="proposerName" className="block text-sm font-medium text-gray-600 mb-1">
                  Name of the Proposer / Introducer 
                </label>
                <input
                  type="text"
                  id="proposerName"
                  name="proposerName"
                  value={formData.proposerName} 
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

            </div>
          </div>

          {/* Media Details Section */}
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-3xl font-semibold text-blue-800 mb-6 uppercase">
              Media Details
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              
              {/* Media Type */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Media Type <span className="text-red-500">*</span>
                </label>
                <div className="flex flex-wrap gap-4">
                  {['TV Media', 'Radio Media'].map((type) => (
                    <div key={type} className="flex items-center">
                      <input
                        type="radio"
                        id={`mediaType_${type}`}
                        name="mediaType"
                        value={type === 'TV Media' ? 'tv' : 'radio'}
                        checked={formData.mediaType === (type === 'TV Media' ? 'tv' : 'radio')}
                        onChange={handleChange}
                        required
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <label htmlFor={`mediaType_${type}`} className="ml-2 text-sm text-gray-700">
                        {type}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

               {/* Name of the Channel Identity */}
               <div className="md:col-span-2">
                <label htmlFor="channelIdentityName" className="block text-sm font-medium text-gray-700 mb-1">
                  Name of the Channel Identity <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="channelIdentityName"
                  name="channelIdentityName"
                  value={formData.channelIdentityName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               {/* Company Name */}
               <div className="md:col-span-2">
                <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1">
                  Company Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Proprietor Name */}
              <div className="md:col-span-2">
                <label htmlFor="proprietorName" className="block text-sm font-medium text-gray-700 mb-1">
                  Proprietor Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="proprietorName"
                  name="proprietorName"
                  value={formData.proprietorName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Phone */}
              <div className="md:col-span-2">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                  Phone <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Email */}
              <div className="md:col-span-2">
                <label htmlFor="channelEmail" className="block text-sm font-medium text-gray-700 mb-1">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="channelEmail"
                  name="channelEmail"
                  value={formData.channelEmail}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               {/* Channel Regd. No */}
               <div className="md:col-span-2">
                <label htmlFor="channelRegdNo" className="block text-sm font-medium text-gray-700 mb-1">
                  Channel Regd. No <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="channelRegdNo"
                  name="channelRegdNo"
                  value={formData.channelRegdNo}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Website */}
              <div className="md:col-span-2">
                <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-1">
                  Website
                </label>
                <input
                  type="text"
                  id="website"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Category */}
               <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Category <span className="text-red-500">*</span>
                </label>
                <div className="flex flex-wrap gap-4">
                  {['News', 'Non-News', 'Religious'].map((cat) => (
                    <div key={cat} className="flex items-center">
                      <input
                        type="radio"
                        id={`category_${cat}`}
                        name="category"
                        value={cat === 'Non-News' ? 'non_news' : cat.toLowerCase()}
                        checked={formData.category === (cat === 'Non-News' ? 'non_news' : cat.toLowerCase())}
                        onChange={handleChange}
                        required
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <label htmlFor={`category_${cat}`} className="ml-2 text-sm text-gray-700">
                        {cat}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

               {/* Channel Language */}
               <div className="md:col-span-2">
                <label htmlFor="channelLanguage" className="block text-sm font-medium text-gray-700 mb-1">
                  Channel Language <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="channelLanguage"
                  name="channelLanguage"
                  value={formData.channelLanguage}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Year of Started */}
              <div className="md:col-span-2">
                <label htmlFor="yearStarted" className="block text-sm font-medium text-gray-700 mb-1">
                  Year of Started <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="yearStarted"
                  name="yearStarted"
                  value={formData.yearStarted}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Editor Name */}
               <div className="md:col-span-2">
                <label htmlFor="editorName" className="block text-sm font-medium text-gray-700 mb-1">
                  Editor Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="editorName"
                  name="editorName"
                  value={formData.editorName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               {/* Editor Phone */}
               <div className="md:col-span-2">
                <label htmlFor="editorPhone" className="block text-sm font-medium text-gray-700 mb-1">
                  Editor Phone
                </label>
                <input
                  type="tel"
                  id="editorPhone"
                  name="editorPhone"
                  value={formData.editorPhone}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Office Address */}
              <div className="md:col-span-2">
                <label htmlFor="officeAddress" className="block text-sm font-medium text-gray-700 mb-1">
                  Office Address
                </label>
                <textarea
                  id="officeAddress"
                  name="officeAddress"
                  value={formData.officeAddress}
                  onChange={handleChange}
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

            </div>
          </div>

          {/* Document Upload Section - Reuse from PressMedia but adapt if needed. 
              BroadcastingApplication model uses broadcasting folder.
          */}
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Document Upload
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                 <div>
                <label htmlFor="photograph" className="block text-sm font-medium text-gray-700 mb-1">
                  Recent Passport Size Photograph <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="photograph"
                  name="photograph"
                  onChange={handleChange}
                  required
                  accept=".jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: JPG, PNG (Max 2MB)
                </p>
              </div>

              <div>
                <label htmlFor="signature" className="block text-sm font-medium text-gray-700 mb-1">
                  Signature for ID Card <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="signature"
                  name="signature"
                  onChange={handleChange}
                  required
                  accept=".pdf,.jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: PDF, JPG, PNG (Max 2MB)
                </p>
              </div>
            </div>

<br/>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                 <div>
                <label htmlFor="idProof" className="block text-sm font-medium text-gray-700 mb-1">
                  ID Proof (Pan Card)  <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="idProof"
                  name="idProof"
                  onChange={handleChange}
                  required
                  accept=".jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: JPG, PNG (Max 2MB)
                </p>
              </div>

              <div>
                <label htmlFor="addressProof" className="block text-sm font-medium text-gray-700 mb-1">
                  Address Proof (Aadhar Card) <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="addressProof"
                  name="addressProof"
                  onChange={handleChange}
                  required
                  accept=".pdf,.jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: PDF, JPG, PNG (Max 2MB)
                </p>
              </div>

            
            </div>

  <p className='text-xs text-center text-gray-500 mt-6'>You can submit your Front and back of Aadhar card as a ID Proof as well as Address Proof.</p>

             
          </div>

          {/* Declaration Section */}
          <div className="p-6">
            <div className="flex items-start">
              <input
                type="checkbox"
                id="declaration"
                name="declaration"
                checked={formData.declaration}
                onChange={handleChange}
                required
                className="mt-1 mr-3"
              />
              <label htmlFor="declaration" className="text-sm text-gray-700">
                I hereby declare that the information provided above is true and correct to the best of my knowledge. 
                I understand that any false information may lead to rejection of my application.
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <div className="px-6 py-4 bg-gray-50 text-right">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${
                isSubmitting 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
              }`}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Application'}
            </button>
          </div>

          {message && (
            <div className={`m-6 p-4 rounded-md ${
              message.includes('Error') 
                ? 'bg-red-50 text-red-700 border border-red-200' 
                : 'bg-green-50 text-green-700 border border-green-200'
            }`}>
              {message}
            </div>
          )}
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>
            For any queries, please contact us at{' '}
            <a href="mailto:mail@naiindia.in" className="text-blue-600 hover:text-blue-500">
              mail@naiindia.in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Broadcasting;
